export const ArrowLeftIcon = ({ className }: { className?: string }) => (
    <svg
        className={className || ''}
        width="7"
        height="11"
        viewBox="0 0 7 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.793841 5.35116C0.793841 5.18372 0.877441 5.01628 0.96104 4.93255L5.14102 0.746508C5.39182 0.495345 5.80982 0.495345 6.06062 0.746508C6.31142 0.997671 6.31142 1.41628 6.06062 1.66744L2.29863 5.43488L6.06062 9.20232C6.31142 9.45349 6.31142 9.87209 6.06062 10.1233C5.80982 10.3744 5.39182 10.3744 5.14102 10.1233L0.96104 5.93721C0.877441 5.60232 0.793841 5.43488 0.793841 5.35116Z"
            fill="#333333"
        />
    </svg>
);
